import React, { memo, useEffect, useState, useRef, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import Lottie from 'lottie-react'
import Slider from 'react-slick'
import { useDispatch } from 'react-redux'

import Text from '../../../components/atoms/Text'
import MobileLayout from '../../../components/MobileLayout'
import Button from '../../../components/atoms/GoodFlipButton'
import { PlayIcon } from '../../../components/atoms/PlayIcon'
import ArrowIcon from '../../../components/atoms/Arrow'
import ZydusHeader from '../../../components/molecules/ZydusHeader'
import BottomSheet from '../../../components/atoms/BottomSheet'

import { trackEventCKD } from '../../../analytics'
import { EVENTS } from '../../../analytics/events'
import { setCapturedImage } from '../../../redux/slices'

import SouthWomenGreen3Img from '../../../assets/images/women3.webp'
import SouthWomenGreen4Img from '../../../assets/images/women4.webp'
import Man2Img from '../../../assets/images/man2.webp'
// import ZydusImg from '../../../assets/images/zydus.png'
import CDKHomeBackDesign2 from '../../../assets/images/ckd-home-design-2.svg'
import CDKStatsImg from '../../../assets/images/ckd-stats.webp'
import VikasKhanna1Img from '../../../assets/images/vikas_khanna_1.webp'
import VikasKhanna2Img from '../../../assets/images/vikas_khanna_2.webp'
import VikasKhanna3Img from '../../../assets/images/vikas_khanna_3.png'
import CKDBookImg from '../../../assets/images/ckd-book.webp'
import BottomCardHeader from '../../../assets/images/bottom_card_header.webp'
import BottomCardFooter from '../../../assets/images/bottom_card_footer.webp'
import TestimonialThumbnail1 from '../../../assets/images/testimonial_thumbnail_1.webp'
import TestimonialThumbnail2 from '../../../assets/images/testimonial_thumbnail_2.webp'
import TestimonialProfile1 from '../../../assets/images/testimonialProfile1.png'
import TestimonialProfile2 from '../../../assets/images/testimonial_thumbnail_2.webp'
import FlaskImg from '../../../assets/images/blue_flask.webp'
import FoodScanAnimation from '../../../assets/animations/food_scan_animation.json'
import ScoredAnimation from '../../../assets/animations/scored_animation.json'
import CancelIcon from '../../../assets/icons/cancel_icon.svg'
import CloseIcon from '../../../assets/icons/close_2.svg'
// import HomeBannerDollyImg from '../../../assets/images/home_banner_dolly.webp'
// import HomeBannerVikasKhannaImg1 from '../../../assets/images/vikas_khanna_with_dr_1.webp'
// import HomeBannerVikasKhannaImg2 from '../../../assets/images/vikas_khanna_with_dr_2.webp'
// import HomeBannerIMG1 from '../../../assets/images/home_banner_1.webp'
// import HomeBannerIMG2 from '../../../assets/images/home_banner_2.webp'
// import HomeBannerIMG3 from '../../../assets/images/home_banner_3.webp'
// import HomeBannerIMG4 from '../../../assets/images/home_banner_4.webp'
// import HomeBannerIMG5 from '../../../assets/images/home_banner_5.webp'
// import HomeBannerIMG6 from '../../../assets/images/home_banner_6.webp'
// import HomeBannerIMG7 from '../../../assets/images/home_banner_7.webp'
// import HomeBannerIMG8 from '../../../assets/images/home_banner_8.webp'
// import HomeBannerIMG9 from '../../../assets/images/home_banner_9.webp'
import HomeBannerIMG10 from '../../../assets/images/home_banner_10.webp'
import HomeBannerIMG10Des from '../../../assets/images/home_banner_10_des.webp'
import HomeBannerIMG11 from '../../../assets/images/home_banner_11.webp'
import HomeBannerIMG11Des from '../../../assets/images/home_banner_11_des.webp'
import ZydusLogo from '../../../assets/images/zydus_logo.webp'
import LifeKaFilterLogo from '../../../assets/images/life_ka_filter_logo.webp'
import TatvaLogo from '../../../assets/images/tatva_logo.webp'
// import LikeKaFilterImg from '../../../assets/images/likeka-filter.png'
import DownArrowIcon from '../../../assets/icons/down_arrow.svg'
import TranslateIcon from '../../../assets/icons/translate.png'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { CKD_PHASE, getInfluencerCardsData } from '../../../constants/common'

const languages = [
  { name: 'English', displayName: 'English' },
  // { name: "Hindi", displayName: "हिन्दी" },
  { name: 'Tamil', displayName: 'தமிழ்' },
  { name: 'Kannada', displayName: 'ಕನ್ನಡ' },
  // { name: 'Telugu', displayName: 'తెలుగు' },
]

export const Footer = () => {
  return (
    <div className="w-screen relative left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#EFE8EF] to-[#E1ECF2] mt-2">
      <div className="px-10 py-8 lg:py-12 lg:px-16 max-w-5xl xl:max-w-6xl mx-auto">
        <div className="flex justify-between items-center w-full mb-12">
          <div className="flex items-center">
            <img src={ZydusLogo} alt="zydus" className="w-20 lg:w-28" />
            <img
              src={LifeKaFilterLogo}
              alt="life ka filter"
              className="w-20 lg:w-[104px] ml-2"
            />
          </div>
          <div className="flex items-center">
            <img src={TatvaLogo} alt="tatva" className="w-20 lg:w-28" />
          </div>
        </div>

        <div className="text-xs lg:text-sm">Powered By GoodFlip</div>
        <div className="text-xs lg:text-sm">All Rights Reserved.</div>
        <div className="text-xs lg:text-sm">
          <span
            className="font-semibold underline text-background-brand-teal cursor-pointer"
            onClick={() =>
              window.open(
                'https://easiestexam.com/terms-and-conditions/',
                '_black',
              )
            }
          >
            Terms and Conditions, and Disclaimer
          </span>{' '}
          and{' '}
          <span
            className="font-semibold underline text-background-brand-teal cursor-pointer"
            onClick={() =>
              window.open('https://easiestexam.com/privacy-policy/', '_black')
            }
          >
            Privacy Policy
          </span>
        </div>
        <div className="text-xs lg:text-sm mt-12 lg:max-w-2xl">
          The content on this website is for educational purposes only and is
          not a substitute for professional medical advice, diagnosis, or
          treatment. Always consult your doctor or healthcare provider with any
          medical concerns
        </div>
      </div>
    </div>
  )
}

const CKDLendingPage = () => {
  const navigate = useNavigate()
  const HomeSectionRef = useRef(null)
  const languageSheetRef = useRef(null)

  const dispatch = useDispatch()

  const [activeHomeSlide, setActiveHomeSlide] = useState(0)
  const [activeFeatureSlide, setActiveFeatureSlide] = useState(0)
  const [showBottomTab, setShowBottomTab] = useState(false)
  const [youtubeVideoId, setYoutubeVideoId] = useState(null)
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('ln') || 'English',
  )

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        setShowBottomTab(!entry.isIntersecting)
      },
      {
        threshold: 0.7,
      },
    )
    if (HomeSectionRef.current) {
      observer.observe(HomeSectionRef.current)
    }
    return () => {
      if (HomeSectionRef.current) {
        observer.unobserve(HomeSectionRef.current)
      }
    }
  }, [])

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    beforeChange: (_oldIndex, newIndex) => setActiveHomeSlide(newIndex),
    appendDots: (dots) => (
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <ul
          className="dot-parent"
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            padding: '0px',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: i === activeHomeSlide ? '#000000' : '#C4C4C480',
          border: 'none',
          transition: 'background-color 0.3s ease',
          cursor: 'pointer',
          position: 'relative',
          top: '-35px',
        }}
      />
    ),
  }

  const setting2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    beforeChange: (_oldIndex, newIndex) => setActiveFeatureSlide(newIndex),
    appendDots: (dots) => (
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <ul
          className="dot-parent"
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            padding: '0px',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: i === activeFeatureSlide ? '#000000' : '#C4C4C480',
          border: 'none',
          transition: 'background-color 0.3s ease',
          cursor: 'pointer',
        }}
      />
    ),
  }

  const influencerCards = useMemo(
    () => getInfluencerCardsData(selectedLanguage),
    [selectedLanguage],
  )

  const onClickBannerButton = (from, isFromTop = true) => {
    const eventMapping = {
      kidney_score: {
        top: EVENTS.CKD_LKF_GetKidneyScore1,
        bottom: EVENTS.CKD_LKF_GetKidneyScore2,
        route: '/ckd/questionnaire?from=SCORED&fromButtonPress=true',
      },
      scan_now: {
        top: EVENTS.CKD_LKF_ScanFood1,
        bottom: EVENTS.CKD_LKF_ScanFood2,
        route: '/scan-food/capture',
      },
      book_test: {
        top: EVENTS.CKD_LKF_BookLabTest1,
        bottom: EVENTS.CKD_LKF_BookLabTest2,
        route: '/book-diagnostic?fromButtonPress=true',
      },
    }

    const selected = eventMapping[from] || eventMapping.book_test
    console.log(
      'trackEventCKD --> ',
      isFromTop ? selected.top : selected.bottom,
    )
    trackEventCKD(isFromTop ? selected.top : selected.bottom)
    if (from === 'scan_now') dispatch(setCapturedImage(null))
    navigate(selected.route)
  }

  // const homeSectionData = [
  //   {
  //     title: 'CKD is Silent. Don’t Let It Go Undetected',
  //     description:
  //       'Most people with CKD are unaware. Assess your risk and take action with diagnostics and personalized care',
  //     buttonText: 'Get Your Kidney Score',
  //     onclick: () => onClickBannerButton('kidney_score', true),
  //     image: SouthWomenGreen3Img,
  //     bgColor: 'bg-background-accent-indigo',
  //     textColor: 'text-text-accent-indigo-primary',
  //     animation: ScoredAnimation,
  //     isAnimation: true,
  //     isImageFirst: false,
  //     animationClass: '',
  //     imageClass: 'right-5',
  //   },
  //   {
  //     title: 'Is Your Meal Kidney-Friendly?',
  //     description:
  //       'Scan your food and instantly check if it supports your kidney health. Make better choices with AI-powered insights',
  //     buttonText: 'Scan Now',
  //     onclick: () => onClickBannerButton('scan_now', true),
  //     image: Man2Img,
  //     bgColor: 'bg-background-accent-gold',
  //     textColor: 'text-text-accent-gold-primary',
  //     animation: FoodScanAnimation,
  //     isAnimation: true,
  //     isImageFirst: true,
  //     animationClass: 'right-6 z-30 ',
  //     imageClass: 'left-6 scale-125 ',
  //   },
  //   {
  //     title: 'Know Your Kidney  with Diagnostics',
  //     description:
  //       'Early detection is key to preventing CKD complications. Get tested for vital kidney health markers and take control today.',
  //     buttonText: 'Book Diagnostics',
  //     onclick: () => onClickBannerButton('book_diagnostics', true),
  //     image: SouthWomenGreen4Img,
  //     bgColor: 'bg-background-accent-teal',
  //     textColor: 'text-foreground-accent-teal-primary',
  //     animation: FlaskImg,
  //     isAnimation: false,
  //     isImageFirst: false,
  //     animationClass: 'relative -bottom-7 left-3 mb-1',
  //     imageClass: 'relative -left-4',
  //   },
  // ]

  const homeBannerData = [
    {
      img: HomeBannerIMG11,
      imgDesktop: HomeBannerIMG11Des,
      onClick: () => {
        handlePlay('GiwdaNp7h4Y')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG10,
      imgDesktop: HomeBannerIMG10Des,
      onClick: () => {
        handlePlay('E-tAC0X40t0')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    // {
    //   img: HomeBannerIMG9,
    //   onClick: () => {
    //     handlePlay('E_-yVJsULZk')
    //   },
    // },
    // {
    //   img: HomeBannerIMG8,
    //   onClick: () => {
    //     handlePlay('9OoY53Ngduk')
    //   },
    // },
    // {
    //   img: HomeBannerIMG7,
    //   onClick: () => {
    //     handlePlay('BOXB01O1LmU')
    //   },
    // },
    // {
    //   img: HomeBannerIMG6,
    //   onClick: () => {
    //     handlePlay('bXLqMedwz_I')
    //   },
    // },
    // {
    //   img: HomeBannerIMG5,
    //   onClick: () => {
    //     handlePlay('trVDkUv5LpU')
    //   },
    // },
    // {
    //   img: HomeBannerVikasKhannaImg1,
    //   onClick: () => {
    //     handlePlay('MHSVDWZnXqQ')
    //   },
    // },
    // {
    //   img: HomeBannerVikasKhannaImg2,
    //   onClick: () => {
    //     handlePlay('qnYpXHOVYY0')
    //   },
    // },
    // {
    //   img: HomeBannerDollyImg,
    //   onClick: () => {
    //     handlePlay('fAun0a3zTlA')
    //   },
    // },
    // {
    //   img: HomeBannerIMG1,
    //   onClick: () => {},
    // },
    // {
    //   img: HomeBannerIMG2,
    //   onClick: () => {},
    // },
    // {
    //   img: HomeBannerIMG3,
    //   onClick: () => {},
    // },
    // {
    //   img: HomeBannerIMG4,
    //   onClick: () => {},
    // },
  ]

  const testimonialData = [
    {
      profile: TestimonialProfile1,
      name: 'Shradha Patel',
      profession: 'Home maker',
      review:
        'I never imagined my life would change so drastically, but CKD taught me resilience. Every choice I make now is for a healthier tomorrow',
      thumbnail: TestimonialThumbnail1,
      url: '',
    },
    {
      profile: TestimonialProfile2,
      name: 'Puneet Kataria',
      profession: 'Investment partner',
      review:
        'The hardest part was accepting my diagnosis. The best part was realizing I could still take control of my health',
      thumbnail: TestimonialThumbnail2,
      url: '',
    },
  ]

  const trackLandingEvent = () => {
    console.log('trackEventCKD --> CKD_LKF_MainPageLanding')
    trackEventCKD(EVENTS.CKD_LKF_MainPageLanding)
  }

  const onClickViewBook = () => {
    console.log('trackEventCKD --> CKD_LKF_DownloadBook')
    trackEventCKD(EVENTS.CKD_LKF_DownloadBook)

    // VIEW BOOK
    navigate('/ckdbook?from=CKD')

    // DOWNLOAD LOGIC
    // try {
    //   const link = document.createElement('a')
    //   link.href = '/files/copd-intro.pdf'
    //   link.download = 'kidney-friendly-recipes.pdf'
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // } catch (error) {
    //   console.error('Download failed:', error)
    // }
  }

  const normalizeYoutubeId = (input) => {
    if (!input) return null
    const trimmed = String(input).trim()
    if (/^[\w-]{11}$/.test(trimmed)) return trimmed

    try {
      const url = new URL(trimmed)
      const host = url.hostname.replace(/^www\./, '')
      if (host === 'youtu.be') {
        const id = url.pathname.replace(/^\//, '')
        return id || null
      }
      if (host.endsWith('youtube.com')) {
        const v = url.searchParams.get('v')
        if (v) return v
        const pathParts = url.pathname.split('/').filter(Boolean)
        const embedIndex = pathParts.indexOf('embed')
        if (embedIndex >= 0 && pathParts[embedIndex + 1]) {
          return pathParts[embedIndex + 1]
        }
      }
    } catch (_err) {
      // fall through to return trimmed value
    }

    return trimmed
  }

  const getYoutubeEmbedSrc = (videoId) => {
    const id = normalizeYoutubeId(videoId)
    if (!id) return null
    const params = new URLSearchParams({
      autoplay: '1',
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
    })
    if (typeof window !== 'undefined' && window.location?.origin) {
      params.set('origin', window.location.origin)
    }
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`
  }

  const handlePlay = (videoId) => {
    setYoutubeVideoId(normalizeYoutubeId(videoId))
  }
  const handleClose = () => {
    setYoutubeVideoId(null)
  }

  const handleSelectLanguage = (language) => {
    setSelectedLanguage(language)
  }

  useEffect(() => {
    trackLandingEvent()
  }, [])

  return (
    <>
      <MobileLayout>
        <div>
          <ZydusHeader />
          {/* Home Slider */}
          <div className="w-full lg:w-screen lg:relative lg:left-1/2 lg:-translate-x-1/2 lg:h-screen lg:overflow-hidden">
            <div className="w-full lg:h-full" ref={HomeSectionRef}>
              <Slider
                {...settings}
                className="w-full lg:h-full home-hero-slider"
              >
                {homeBannerData.map((banner, index) => (
                  <div
                    key={index}
                    className="flex flex-col lg:h-full"
                    onClick={banner.onClick}
                  >
                    <div className="relative w-full lg:h-full">
                      {banner.imgDesktop ? (
                        <picture className="block w-full lg:h-full">
                          <source
                            media="(min-width: 1024px)"
                            srcSet={banner.imgDesktop}
                          />
                          <img
                            src={banner.img}
                            alt={`home_banner_${index}`}
                            className="h-auto w-full lg:h-full lg:w-full lg:object-cover"
                          />
                        </picture>
                      ) : (
                        <img
                          src={banner.img}
                          alt={`home_banner_${index}`}
                          className="h-auto w-full lg:h-full lg:w-full lg:object-cover"
                        />
                      )}
                      {banner?.showButton && (
                        <Button
                          title={banner?.buttonTitle || 'Click Here'}
                          onClick={banner.onClick}
                          rightIcon={
                            <ArrowIcon direction="right" color="#199EA5" />
                          }
                          leftIcon={null}
                          className="!w-[90%] lg:!w-[60%] lg:!max-w-[652px] !absolute !bottom-8 !left-1/2 !-translate-x-1/2"
                        />
                      )}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* CKD Recipes */}
          {CKD_PHASE >= 3 && (
            <div className="p-4 lg:px-8 mt-12 lg:mt-20 flex flex-col gap-9">
              <div className="flex flex-col gap-2 lg:max-w-2xl">
                <Text
                  variant="display"
                  size="small"
                  className={'text-foreground-primary'}
                >
                  Flavors That Care –{' '}
                  <span className="!text-[#199EA5]">Vikas Khanna</span>
                  ’s CKD Recipes
                </Text>
                <Text
                  variant="body"
                  size="large"
                  className={'!text-foreground-quaternary !font-light'}
                >
                  Celebrity Chef Vikas Khanna brings you kidney-friendly recipes
                  that are both delicious and healthy. Watch exclusive videos
                  and explore his special cookbook!
                </Text>
              </div>

              {/* Video Section */}
              <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                {/* Main Video */}
                <div>
                  <div className="relative flex items-center justify-center">
                    <img
                      src={VikasKhanna1Img}
                      className="w-full rounded-lg border border-[#FED15E]"
                    />
                    <div
                      className="absolute"
                      onClick={() => handlePlay('DUOjTQKjT94')}
                    >
                      <PlayIcon className="opacity-70" />
                    </div>
                    <div className="bg-[#171725B2] absolute right-2 bottom-2 h-5 w-9 rounded-1 flex items-center justify-center">
                      <p className="text-xs text-white ">13:40</p>
                    </div>
                  </div>
                  <div className="mt-1">
                    <p className="font-roboto font-semibold text-sm text-[#454551]">
                      {' '}
                      Kidney friendly white sauce pasta
                    </p>
                    <p className="text-[#A2A2A8] text-sm ">
                      A creamy and delicious white sauce pasta made with
                      kidney-safe ingredients. Low in sodium, rich in flavor!
                    </p>
                  </div>
                </div>

                {/* Secondary Videos */}
                <div className="mt-9 lg:mt-0 flex flex-col gap-10 lg:justify-center">
                  <div className="w-full flex items-center justify-center gap-4">
                    <div className="w-[33%] relative flex items-center justify-center">
                      <img
                        src={VikasKhanna2Img}
                        className="w-full  rounded-lg border border-[#FED15E]"
                      />
                      <div
                        className="absolute"
                        onClick={() => handlePlay('bR84T112nPw')}
                      >
                        <PlayIcon className="opacity-70" />
                      </div>
                      <div className="bg-[#171725B2] absolute right-1 bottom-1 h-5 w-9 rounded-1 flex items-center justify-center">
                        <p className="text-xs text-white ">06:07</p>
                      </div>
                    </div>
                    <div className="w-[67%]">
                      <p className="font-roboto font-semibold text-sm text-[#454551]">
                        {' '}
                        Kidney friendly rajma chawal
                      </p>
                      <p className="text-[#A2A2A8] text-sm  line-clamp-2">
                        A nutritious twist on the classic rajma chawal, packed
                        with plant-based protein and lower potassium
                        alternatives
                      </p>
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-center gap-4">
                    <div className="w-[33%] relative flex items-center justify-center">
                      <img
                        src={VikasKhanna3Img}
                        className="w-full  rounded-lg border border-[#FED15E]"
                      />
                      <div
                        className="absolute"
                        onClick={() => handlePlay('MNP3x3hGDfE')}
                      >
                        <PlayIcon className="opacity-70" />
                      </div>
                      <div className="bg-[#171725B2] absolute right-1 bottom-1 h-5 w-9 rounded-1 flex items-center justify-center">
                        <p className="text-xs text-white ">06:52</p>
                      </div>
                    </div>
                    <div className="w-[67%]">
                      <p className="font-roboto font-semibold text-sm text-[#454551]">
                        {' '}
                        Kidney friendly masala dosa
                      </p>
                      <p className="text-[#A2A2A8] text-sm  line-clamp-2">
                        A crispy, golden masala dosa with a filling that's easy
                        on the kidneys and full of flavor
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Book section */}
          <div className="p-4 lg:px-8 mt-16 lg:mt-20">
            {/* card */}
            <div className="bg-[#E6FAF8] border border-[#299B9D] rounded-2xl p-4 lg:p-8 lg:flex lg:items-center lg:gap-8">
              <div className="relative lg:static lg:flex-shrink-0 lg:w-48">
                <img
                  src={CKDBookImg}
                  className="absolute top-0 -left-[16px] h-[240px] w-auto -translate-y-[39%] lg:static lg:translate-y-0 lg:h-auto lg:w-full"
                />
              </div>
              <div className="lg:flex-1">
                <div className="ml-[150px] mt-4 h-[103px] lg:ml-0 lg:mt-0 lg:h-auto">
                  <Text
                    tag={'div'}
                    variant={'title'}
                    size="large"
                    className={'text-text-brand-primary'}
                  >
                    A curated guide to nourishment and resilience
                  </Text>
                </div>
                <div className="lg:mt-3">
                  <Text
                    variant="label"
                    size="medium"
                    className={'text-foreground-primary'}
                  >
                    Explore kidney-friendly recipes crafted with care for CKD
                    patients, and discover inspiring stories of strength and
                    hope from real-life kidney warriors.
                  </Text>
                </div>
                <div className="w-3/4 lg:w-auto lg:max-w-xs mt-6">
                  <button
                    onClick={onClickViewBook}
                    className="w-full py-1 lg:py-2 bg-[#199EA5] text-white flex items-center justify-center rounded-lg cursor-pointer hover:bg-[#158a90] transition-colors"
                  >
                    <Text variant="label" size="medium">
                      View Life Ka Filter Book
                    </Text>{' '}
                    <ArrowIcon direction="right" className="ml-1" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* what is chronic disease */}
          <div className="w-full relative p-4 lg:px-8 flex flex-col items-center justify-center gap-8 lg:gap-0">
            <img
              src={CDKHomeBackDesign2}
              className="absolute top-0 left-0 -z-10"
            />
            <div className="mt-[86px] lg:mt-24 text-foreground-primary flex flex-col gap-2 lg:flex-row lg:items-start lg:gap-16 w-full">
              <div className="flex flex-col gap-4 lg:flex-1">
                <Text variant="display" size="small" tag="p">
                  What is Chronic Kidney Disease (
                  <span className="!text-[#199EA5]">CKD</span>)?
                </Text>
                <Text variant="body" size="large">
                  CKD is a progressive loss of kidney function that affects
                  millions worldwide. Early detection can prevent complications
                </Text>
                <div className="hidden lg:flex flex-col mt-6">
                  <Text variant="body" size="large">
                    Want to know more Chronic Kidney Disease?
                  </Text>
                  <Text
                    tag="p"
                    variant="label"
                    size="large"
                    className="!text-[#199EA5] !font-semibold flex gap-1.5 items-center"
                  >
                    <span
                      className="underline cursor-pointer"
                      onClick={() => navigate('/about')}
                    >
                      Learn More
                    </span>{' '}
                    <ArrowIcon color="#199EA5" direction="right" />
                  </Text>
                </div>
              </div>
              <div className="lg:flex-1 flex justify-center">
                <img src={CDKStatsImg} className="h-[358px] lg:h-[420px]" />
              </div>
            </div>
            <div className="flex flex-col items-center justify-center lg:hidden">
              <Text variant="body" size="large">
                Want to know more about Chronic Kidney Disease?
              </Text>
              <Text
                tag="p"
                variant="label"
                size="large"
                className={
                  '!text-[#199EA5] !font-semibold flex gap-1.5 items-center'
                }
              >
                <span
                  className="underline cursor-pointer"
                  onClick={() => navigate('/about')}
                >
                  Learn More
                </span>{' '}
                <ArrowIcon color="#199EA5" direction="right" />
              </Text>
            </div>
          </div>

          {/* GoodFlip influencers slider */}
          {CKD_PHASE >= 2 && (
            <div className="mt-14 lg:mt-20 flex flex-col">
              <div className="p-4 lg:px-8 flex flex-col gap-2 lg:max-w-2xl">
                <Text
                  variant="display"
                  size="small"
                  className={'text-foreground-primary'}
                >
                  See what the{' '}
                  <span className="!text-[#199EA5]">influencers</span> have to
                  say about CKD
                </Text>
              </div>

              {/* Horizontal scrollable container */}
              <div className="bg-[#199EA515] lg:border lg:rounded-2xl">
                <div className="px-4 lg:px-8 flex h-12 mt-4 justify-between items-center">
                  <Text
                    variant="body"
                    size="large"
                    tag="p"
                    className="!text-[#199EA5] pl-1 !font-manrope"
                    bold="true"
                  >
                    Select Language
                  </Text>
                  <div
                    className="p-2.5 h-fit w-36 border-[1.8px] border-[#199EA5] rounded-6 flex justify-between items-center cursor-pointer"
                    onClick={() => {
                      languageSheetRef?.current?.open()
                    }}
                  >
                    <img src={TranslateIcon} alt="icon" />
                    <Text
                      variant="body"
                      size="medium"
                      tag="p"
                      className="!text-[#199EA5] !font-manrope"
                      bold="true"
                    >
                      {selectedLanguage}
                    </Text>
                    <img src={DownArrowIcon} alt="icon" />
                  </div>
                </div>
                <div className="p-4 lg:px-8 w-full relative">
                  <div className="flex overflow-x-auto space-x-4 snap-x lg:grid lg:grid-cols-3 lg:gap-6 lg:space-x-0 lg:overflow-x-visible">
                    {influencerCards.map((card) => (
                      <div
                        key={card.id}
                        className="flex-none w-64 lg:w-auto rounded-3xl overflow-hidden relative snap-center cursor-pointer"
                        onClick={() => handlePlay(card.videoId)}
                      >
                        <div className="relative">
                          <img
                            src={card.image}
                            alt={`Influencer ${card.id}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* GoodFLip card slider */}
          <div className="mt-12 lg:mt-20 relative">
            <div className="p-4 lg:px-8 z-10 relative">
              {/* upper text */}
              <div className="text-foreground-primary flex flex-col gap-2 lg:max-w-3xl">
                <Text variant="display" size="small" tap="p">
                  <span className="text-[#199EA5]">GoodFlip</span>: Your Partner
                  in Kidney Health
                </Text>
                <Text variant="body" size="large" tag="p">
                  Managing CKD starts with the right tools. GoodFlip helps you
                  assess, track, and take action—so you stay in control of your
                  kidney health
                </Text>
              </div>

              {/* Mobile Slider */}
              <div className="mb-10 flex items-center justify-center lg:hidden">
                <Slider {...setting2} className="w-[98%] max-w-[385px]">
                  <div>
                    {/* card 1 */}
                    <div className="">
                      <div className="relative w-full top-[34px]">
                        <img
                          src={BottomCardHeader}
                          className="rounded-tr-3xl"
                        />
                      </div>
                      <div className="bg-gradient-to-l to-[#EFE8EF] from-[#E1ECF2] p-4 flex flex-col items-center h-[432px]">
                        <div className="h-6 w-[90px] flex items-center justify-center rounded-2xl bg-gradient-to-r from-GOLD-900 via-GOLD-700 to-GOLD-900">
                          <Text
                            variant="label"
                            size="small"
                            className={'text-white'}
                          >
                            Food Scanner
                          </Text>
                        </div>
                        <div className="mt-3">
                          <Text
                            variant="headline"
                            size="large"
                            className={'text-foreground-primary'}
                            textalign="center"
                            tag="p"
                          >
                            Is Your Meal Good for your Kidney?
                          </Text>
                          <Text
                            variant="body"
                            size="medium"
                            className={'text-text-quartenary mt-2.5'}
                            tag="p"
                            textalign="center"
                          >
                            Scan your food and enter a few details to analyze
                            your meal for better kidney care
                          </Text>
                        </div>
                        <div className="w-full flex mt-4 items-center">
                          <img
                            src={Man2Img}
                            className="w-1/2 relative top-3 left-6"
                          />
                          <div className="w-1/2 relative right-5">
                            <Lottie
                              animationData={FoodScanAnimation}
                              autoplay
                              autoPlay
                              loop
                            />
                          </div>
                        </div>
                        <div className="w-full relative -top-[33px]">
                          <Button
                            title={'Scan Now'}
                            onClick={() =>
                              onClickBannerButton('scan_now', false)
                            }
                            className="!mt-0"
                            type="goodflip_primary"
                            rightIcon={<ArrowIcon direction="right" />}
                          />
                        </div>
                      </div>
                      <div className="relative w-full bottom-[16px]">
                        <img
                          src={BottomCardFooter}
                          className="rounded-bl-3xl"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    {/* card 2 */}
                    <div className="mx-2">
                      <div className="relative w-full top-[34px]">
                        <img
                          src={BottomCardHeader}
                          className="rounded-tr-3xl"
                        />
                      </div>
                      <div className="bg-gradient-to-l to-[#EFE8EF] from-[#E1ECF2] p-4 flex flex-col items-center h-[432px]">
                        <div className="h-6 w-[124px] flex items-center justify-center rounded-2xl bg-gradient-to-r from-INDIGO-900 via-INDIGO-800 to-INDIGO-900">
                          <Text
                            variant="label"
                            size="small"
                            className={'text-white'}
                          >
                            Kidney Health Score
                          </Text>
                        </div>
                        <div className="mt-3">
                          <Text
                            variant="headline"
                            size="large"
                            className={'text-foreground-primary'}
                            textalign="center"
                            tag="p"
                          >
                            Decode Your Kidney Health!
                          </Text>
                          <Text
                            variant="body"
                            size="medium"
                            className={'text-text-quartenary mt-2.5'}
                            tag="p"
                            textalign="center"
                          >
                            Answer a few quick questions to get your Kidney
                            Profile Score
                          </Text>
                        </div>
                        <div className="w-full flex mt-4 items-center">
                          <div className="w-1/2 relative left-5">
                            <Lottie
                              animationData={ScoredAnimation}
                              autoplay
                              autoPlay
                              loop
                            />
                          </div>
                          <img
                            src={SouthWomenGreen3Img}
                            className="w-1/2 right-2 relative"
                          />
                        </div>
                        <div className="w-full relative -top-[33px]">
                          <Button
                            title={'Get Your Score'}
                            onClick={() =>
                              onClickBannerButton('kidney_score', false)
                            }
                            className="!mt-0"
                            type="goodflip_primary"
                            rightIcon={<ArrowIcon direction="right" />}
                          />
                        </div>
                      </div>
                      <div className="relative w-full bottom-[16px]">
                        <img
                          src={BottomCardFooter}
                          className="rounded-bl-3xl"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    {/* card 3 */}
                    <div className="mx-2">
                      <div className="relative w-full top-[34px]">
                        <img
                          src={BottomCardHeader}
                          className="rounded-tr-3xl"
                        />
                      </div>
                      <div className="bg-gradient-to-l to-[#EFE8EF] from-[#E1ECF2] p-4 flex flex-col items-center h-[432px]">
                        <div className="h-6 w-[124px] flex items-center justify-center rounded-2xl bg-gradient-to-r from-teal-900 via-[#2DA6A6] to-teal-900">
                          <Text
                            variant="label"
                            size="small"
                            className={'text-white'}
                          >
                            Diagnostics
                          </Text>
                        </div>
                        <div className="mt-3">
                          <Text
                            variant="headline"
                            size="large"
                            className={'text-foreground-primary'}
                            textalign="center"
                            tag="p"
                          >
                            Know Your Kidney Vitals
                          </Text>
                          <Text
                            variant="body"
                            size="medium"
                            className={'text-text-quartenary mt-2.5'}
                            tag="p"
                            textalign="center"
                          >
                            Identify key vitals and take the right steps toward
                            better care
                          </Text>
                        </div>
                        <div className="w-full flex mt-4 items-center">
                          <div className="w-1/2 relative left-4 mb-4">
                            <img src={FlaskImg} className="" />
                          </div>
                          <img
                            src={SouthWomenGreen4Img}
                            className="w-1/2 relative right-4"
                          />
                        </div>
                        <div className="w-full relative -top-[33px]">
                          <Button
                            title={'Book Diagnostics'}
                            onClick={() =>
                              onClickBannerButton('book_diagnostics', false)
                            }
                            className="!mt-0"
                            type="goodflip_primary"
                            rightIcon={<ArrowIcon direction="right" />}
                          />
                        </div>
                      </div>
                      <div className="relative w-full bottom-[16px]">
                        <img
                          src={BottomCardFooter}
                          className="rounded-bl-3xl"
                        />
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>

              {/* Desktop Grid */}
              <div className="hidden lg:grid lg:grid-cols-3 lg:gap-6 mt-10 mb-10">
                {[
                  {
                    badge: 'Food Scanner',
                    badgeGradient: 'from-GOLD-900 via-GOLD-700 to-GOLD-900',
                    badgeWidth: 'w-[90px]',
                    title: 'Is Your Meal Good for your Kidney?',
                    desc: 'Scan your food and enter a few details to analyze your meal for better kidney care',
                    leftContent: (
                      <img
                        src={Man2Img}
                        className="w-1/2 relative top-3 left-6"
                      />
                    ),
                    rightContent: (
                      <div className="w-1/2 relative right-5">
                        <Lottie
                          animationData={FoodScanAnimation}
                          autoplay
                          autoPlay
                          loop
                        />
                      </div>
                    ),
                    btnTitle: 'Scan Now',
                    btnAction: () => onClickBannerButton('scan_now', false),
                  },
                  {
                    badge: 'Kidney Health Score',
                    badgeGradient:
                      'from-INDIGO-900 via-INDIGO-800 to-INDIGO-900',
                    badgeWidth: 'w-[124px]',
                    title: 'Decode Your Kidney Health!',
                    desc: 'Answer a few quick questions to get your Kidney Profile Score',
                    leftContent: (
                      <div className="w-1/2 relative left-5">
                        <Lottie
                          animationData={ScoredAnimation}
                          autoplay
                          autoPlay
                          loop
                        />
                      </div>
                    ),
                    rightContent: (
                      <img
                        src={SouthWomenGreen3Img}
                        className="w-1/2 right-2 relative"
                      />
                    ),
                    btnTitle: 'Get Your Score',
                    btnAction: () => onClickBannerButton('kidney_score', false),
                  },
                  {
                    badge: 'Diagnostics',
                    badgeGradient: 'from-teal-900 via-[#2DA6A6] to-teal-900',
                    badgeWidth: 'w-[124px]',
                    title: 'Know Your Kidney Vitals',
                    desc: 'Identify key vitals and take the right steps toward better care',
                    leftContent: (
                      <div className="w-1/2 relative left-4 mb-4">
                        <img src={FlaskImg} />
                      </div>
                    ),
                    rightContent: (
                      <img
                        src={SouthWomenGreen4Img}
                        className="w-1/2 relative right-4"
                      />
                    ),
                    btnTitle: 'Book Diagnostics',
                    btnAction: () =>
                      onClickBannerButton('book_diagnostics', false),
                  },
                ].map((card, idx) => (
                  <div key={idx}>
                    <div className="relative w-full top-[34px]">
                      <img src={BottomCardHeader} className="rounded-tr-3xl" />
                    </div>
                    <div className="bg-gradient-to-l to-[#EFE8EF] from-[#E1ECF2] p-4 flex flex-col items-center h-[432px]">
                      <div
                        className={`h-6 ${card.badgeWidth} flex items-center justify-center rounded-2xl bg-gradient-to-r ${card.badgeGradient}`}
                      >
                        <Text
                          variant="label"
                          size="small"
                          className="text-white"
                        >
                          {card.badge}
                        </Text>
                      </div>
                      <div className="mt-3">
                        <Text
                          variant="headline"
                          size="large"
                          className="text-foreground-primary"
                          textalign="center"
                          tag="p"
                        >
                          {card.title}
                        </Text>
                        <Text
                          variant="body"
                          size="medium"
                          className="text-text-quartenary mt-2.5"
                          tag="p"
                          textalign="center"
                        >
                          {card.desc}
                        </Text>
                      </div>
                      <div
                        className={`w-full flex mt-4 items-center ${idx === 2 ? '!mt-1.5' : ''}`}
                      >
                        {card.leftContent}
                        {card.rightContent}
                      </div>
                      <div className="w-full relative -top-[33px]">
                        <Button
                          title={card.btnTitle}
                          onClick={card.btnAction}
                          className="!mt-0"
                          type="goodflip_primary"
                          rightIcon={<ArrowIcon direction="right" />}
                        />
                      </div>
                    </div>
                    <div className="relative w-full bottom-[16px]">
                      <img src={BottomCardFooter} className="rounded-bl-3xl" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="w-full relative z-10 h-[100px] bg-white"
              style={{ clipPath: 'ellipse(58% 91px at 50% 100%)' }}
            ></div>
            <div className="absolute bottom-0 w-full z-0">
              <div className="h-[300px] w-full bg-gradient-to-b from-white to-background-accent-indigo z-0"></div>
            </div>
          </div>

          {/* Testimonials */}
          {CKD_PHASE >= 3 && (
            <div className="mt-8 lg:mt-16 pb-14">
              {/* upper text */}
              <div className="p-4 lg:px-8">
                <Text
                  variant="display"
                  size="small"
                  tag="div"
                  className={'text-foreground-primary'}
                >
                  {' '}
                  <p className="text-[#199EA5]">Beating CKD:</p>
                  <p>Stories of Hope & Resilience</p>
                </Text>
                <Text
                  className={'text-text-quartenary mt-2.5 lg:max-w-2xl'}
                  variant="body"
                  size="large"
                  tag="p"
                >
                  Your journey doesn’t have to be alone. Hear from those who’ve
                  walked the path, faced CKD, and come out stronger
                </Text>
              </div>

              {/* Testimonial Cards */}
              <div className="mt-7 w-full overflow-scroll flex scroll-hidden lg:overflow-visible lg:grid lg:grid-cols-2 lg:gap-6 lg:px-8">
                {testimonialData.map((data, index) => (
                  <div key={index}>
                    {/* card */}
                    <div className="bg-gradient-to-b w-[334px] lg:w-full from-white to-[#CBEDF0] p-4 lg:p-6 ml-4 lg:ml-0 flex flex-col gap-5 rounded-2xl min-h-[462px]">
                      {/* profile container */}
                      <div className="flex items-center gap-3">
                        <img
                          src={data.profile}
                          className="rounded-full h-[60px] w-[60px]"
                        />
                        <div className="">
                          <Text
                            variant="body"
                            size="large"
                            className={'text-foreground-primary'}
                            tag="p"
                          >
                            {data.name}
                          </Text>
                          <Text
                            variant="body"
                            size="medium"
                            className={'text-text-quartenary'}
                            tag="p"
                          >
                            {data.profession}
                          </Text>
                        </div>
                      </div>
                      <div className="flex gap-1.5 items-start h-[85px]">
                        <Text
                          variant="display"
                          size="large"
                          tag={'p'}
                          className={'relative -top-3'}
                        >
                          “
                        </Text>
                        <Text
                          variant="body"
                          size="medium"
                          className={'text-foreground-primary'}
                        >
                          {data.review}
                        </Text>
                      </div>
                      <div className="w-full relative flex items-center justify-center cursor-pointer">
                        <img
                          src={data.thumbnail}
                          className="h-[240px] w-full rounded-2xl object-cover"
                        />
                        <div className="absolute">
                          <PlayIcon className="opacity-70" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Footer */}
          <Footer />

          {/* Buttons */}
          <div
            className={classNames(
              `px-4 pb-6 pt-2 gap-4 z-50 bg-[#fffffff0] sticky flex bottom-0 w-full border-t-2 transform transition-all duration-400 ease-out animate-slide-up lg:justify-center lg:hidden`,
            )}
          >
            <Button
              title={'Book Test'}
              onClick={() => {
                navigate('/book-diagnostic?fromButtonPress=true')
              }}
              rightIcon={null}
              leftIcon={null}
              className="!w-1/2 lg:!w-auto lg:!min-w-[200px] !m-0 !mt-0"
            />
            <Button
              title={'Scan Food'}
              onClick={() => {
                dispatch(setCapturedImage(null))
                navigate('/scan-food/capture')
              }}
              className="!w-1/2 lg:!w-auto lg:!min-w-[200px] !m-0 !mt-0"
              type="goodflip_primary"
              rightIcon={null}
              leftIcon={null}
            />
          </div>
        </div>

        {youtubeVideoId && (
          <div className="fixed inset-0 bg-black bg-opacity-80 z-[2000] flex items-center justify-center">
            <div
              className="absolute top-4 right-4 z-50 cursor-pointer bg-white p-0.5 border rounded-full"
              onClick={handleClose}
            >
              <img src={CancelIcon} />
            </div>
            <div className="relative w-full max-w-5xl aspect-video mx-4">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={getYoutubeEmbedSrc(youtubeVideoId)}
                title={'youtube video'}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="origin-when-cross-origin"
              ></iframe>
            </div>
          </div>
        )}
      </MobileLayout>

      {/* BottomSheet */}
      <BottomSheet ref={languageSheetRef} onBackdropClick={() => {}}>
        <div className="border-b border-gray-200 p-4 flex justify-between items-center">
          <Text
            variant="body"
            size="large"
            tag="p"
            className="pl-1 !font-manrope"
            bold="true"
          >
            Choose Language
          </Text>
          <button
            onClick={() => {
              languageSheetRef?.current?.hide()
            }}
          >
            <img src={CloseIcon} alt="icon" />
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {languages.map((language) => (
            <button
              key={language.name}
              onClick={() => {
                handleSelectLanguage(language.displayName)
                localStorage.setItem('ln', language.displayName)
                languageSheetRef?.current?.hide()
              }}
              className={`w-full text-left py-3 px-4 border-b border-gray-100 hover:bg-gray-50 focus:outline-none ${
                selectedLanguage === language.displayName ? 'bg-[#EDF7F8]' : ''
              }`}
            >
              <Text
                variant="body"
                size="large"
                tag="p"
                className="pl-1 !font-manrope"
              >
                {language.displayName}
              </Text>
            </button>
          ))}
        </div>
      </BottomSheet>
    </>
  )
}

export default memo(CKDLendingPage)
